<template>
  <div id="summary-container">
    <v-snackbar v-model="snackbar" bottom left :timeout="4000">{{
      snackbarText
    }}</v-snackbar>

    <div>
      <h3 class="pt-5">Qualifications Enrolled</h3>
      <v-row class="mb-5">
        <v-col
          lg="4"
          md="4"
          v-for="(qualification, index) in learnerQualifications"
          :key="qualification._id"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-card
                class="mx-auto py-1 asessment-card"
                v-bind="attrs"
                v-on="on"
              >
                <v-list-item three-line class="ml-0">
                  <v-list-item-content>
                    <v-list-item-title style="font-size: 1.2rem" class="mb-4">{{
                      qualification.name
                    }}</v-list-item-title>

                    <v-list-item-subtitle
                      v-if="certificationCreatedDate[index] != null"
                      >Certified on:
                      {{
                        certificationCreatedDate[index]
                      }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-card-actions>
                  <v-btn
                    v-if="
                      $route.name != 'PendingLearnerDetails' &&
                        !item &&
                        certificationCreatedDate[index] == null
                    "
                    style="background-color: rgba(179, 212, 252, 0.2)"
                    color="primary"
                    text
                    tile
                    @click.stop="drawer = !drawer"
                    @click="
                      onApplyCertification(index, qualification.learnerId)
                    "
                    >Apply certification</v-btn
                  >
                </v-card-actions>
              </v-card>
            </template>
            <span>{{ qualification.name }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </div>

    <v-sheet height="100%" class="overflow-hidden" style="position: relative">
      <v-navigation-drawer
        id="certificate-side-sheet"
        v-model="drawer"
        absolute
        temporary
        right
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="py-3 pl-3"
              >Select unit(s) for certification:</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <p class="pl-4 pt-2" style="text-decoration: underline">
                <strong>Mandatory units</strong>
              </p>
              <v-list>
                <v-list-item-group v-model="selectedUnits" multiple>
                  <template v-for="(item, index) in drawerMandatoryUnits">
                    <v-list-item
                      :key="`item-${index}`"
                      :value="item"
                      active-class="primary--text"
                    >
                      <template v-slot:default="{ active, toggle }">
                        <v-list-item-content>
                          <v-list-item-title
                            >{{ item.code }}: {{ item.name }}</v-list-item-title
                          >
                          <v-list-item-subtitle
                            >Credits: {{ item.credits }}</v-list-item-subtitle
                          >
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            :true-value="item"
                            color="primary"
                            @click="toggle"
                          ></v-checkbox>
                        </v-list-item-action>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>

              <div class="py-5"></div>

              <p class="pl-4" style="text-decoration: underline">
                <strong>Optional units</strong>
              </p>
              <p class="pl-4" v-if="optionalUnits.length < 1">None</p>

              <v-list v-else>
                <v-list-item-group v-model="selectedUnits" multiple>
                  <template v-for="(item, index) in drawerOptionalUnits">
                    <v-list-item
                      :key="`item-${index}`"
                      :value="item"
                      active-class="primary--text"
                    >
                      <template v-slot:default="{ active, toggle }">
                        <v-list-item-content>
                          <v-list-item-title
                            >{{ item.code }}: {{ item.name }}</v-list-item-title
                          >
                          <v-list-item-subtitle
                            >Credits: {{ item.credits }}</v-list-item-subtitle
                          >
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            :true-value="item"
                            color="primary"
                            @click="toggle"
                          ></v-checkbox>
                        </v-list-item-action>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>

              <p class="pt-5 pl-4">
                <strong>Total credits: {{ totalCredits }}</strong>
              </p>

              <v-btn
                class="my-7"
                tile
                :disabled="disableProceedBtn"
                block
                color="primary"
                @click.stop="onProceedGrading()"
              >
                Proceed to grading
                <v-icon size="20" class="mr-1">mdi-chevron-right</v-icon>
              </v-btn>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-navigation-drawer>

      <!-- Second drawer -->
      <v-navigation-drawer
        id="certificate-side-sheet"
        v-model="gradeDrawer"
        absolute
        temporary
        right
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="py-3 pl-3"
              >Provide unit(s) grading:</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="pa-3">
              <template v-if="!gradingOptions">
                <v-row
                  v-for="(unit, index) in filteredSelectedUnits"
                  :key="unit.name"
                >
                  <v-col md="9" class="py-0">
                    <p class="pt-3">{{ unit.name }}</p>
                  </v-col>
                  <v-col md="3" class="py-0">
                    <v-text-field
                      class="mb-0"
                      outlined
                      v-model="grades[index]"
                      @keyup="onEnterGrade(unit.name, index)"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </template>

              <template v-if="gradingOptions">
                <v-row
                  v-for="(unit, index) in filteredSelectedUnits"
                  :key="unit.name"
                >
                  <v-col md="6" class="py-0">
                    <p class="pt-6">{{ unit.name }}</p>
                  </v-col>
                  <v-col md="6" class="py-0">
                    <v-col class="d-flex mr-0" cols="12">
                      <v-select
                        :items="gradingOptions"
                        outlined
                        v-model="grades[index]"
                        @change="onEnterGrade(unit.name, index)"
                      ></v-select>
                    </v-col>
                  </v-col>
                </v-row>
              </template>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="Select assessment Date"
                    prepend-icon="event"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  no-title
                  scrollable
                  @input="$refs.menu.save(date)"
                >
                  <v-spacer></v-spacer>
                </v-date-picker>
              </v-menu>
              <v-btn
                class="my-7"
                tile
                :disabled="disableRequestBtn"
                block
                color="primary"
                @click="onRequestCertification()"
                >Request certification</v-btn
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-navigation-drawer>

      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <tr v-for="item in details" :key="item.name">
              <td>
                <b>{{ item.name }}</b>
              </td>
              <td>{{ item.value }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-sheet>
  </div>
</template>

<script>
export default {
  props: {
    item: Object // learner object passed from LearnerDetails component
  },
  mounted: async function() {
    this.section = this.$route.params.section;
    this.id = this.$route.query.id || this.$route.query.learnerId;
    this.code = this.$route.query.code;
    await this.getQualifications();
    this.getLearner();

    if (this.item) {
      const selectedQualifications = [];

      for (let i = 0; i < this.item.qualification.length; i++) {
        for (let j = 0; j < this.qualifications.length; j++) {
          if (this.item.qualification[i] == this.qualifications[j].code) {
            selectedQualifications.push(this.qualifications[j]);
          }
        }
      }

      this.learnerQualifications = selectedQualifications;
    }
  },
  data() {
    return {
      qualificationIndex: null,
      selectedLearnerId: null,
      totalCredits: 0,
      date: null,
      menu: false,
      snackbar: false,
      snackbarText: "",
      gradingOptions: null,
      certificationCreatedDate: [],
      unitNameAndType: [],
      units: [], // all units of the certifications
      selectedUnits: [], // selected units including certification if selected
      filteredSelectedUnits: [], // selected units after removing qualifications
      mandatoryUnits: [],
      optionalUnits: [],
      unitsIdAndName: [],
      grades: [],
      unitsNameAndGrade: [],
      selectedUnitsId: [],
      drawerMandatoryUnits: [],
      drawerOptionalUnits: [],
      drawer: null,
      gradeDrawer: null,
      gradingCriterion: null,
      details: [],
      learnerQualifications: [],
      qualifications: [],
      mapper: [
        {
          name: "Learner Code",
          mapTo: "code"
        },
        {
          name: "Application Number",
          mapTo: "applicationNumber"
        },
        {
          name: "First Name",
          mapTo: "firstName"
        },
        {
          name: "Middle Name",
          mapTo: "middleName"
        },
        {
          name: "Last Name",
          mapTo: "lastName"
        },
        {
          name: "Date Of Birth",
          mapTo: "dateOfBirth"
        },
        {
          name: "Title",
          mapTo: "title"
        },
        {
          name: "Centre",
          mapTo: "centre"
        },
        {
          name: "First Approved Date",
          mapTo: "firstApprovedDate"
        },
        {
          name: "RenewalDate",
          mapTo: "renewalDate"
        },
        {
          name: "UKPRN / Trainer Number",
          mapTo: "ukprn"
        },
        {
          name: "Status",
          mapTo: "status"
        },
        {
          name: "Unique Learner Number",
          mapTo: "uln"
        },
        {
          name: "Date of Birth",
          mapTo: "dob"
        },
        {
          name: "Ethnicity",
          mapTo: "ethnicity"
        },
        {
          name: "Nationality",
          mapTo: "nationality"
        },
        {
          name: "Phone Number",
          mapTo: "phoneNo"
        },
        {
          name: "Mobile Number",
          mapTo: "mobileNo"
        },
        {
          name: "Emaill Address",
          mapTo: "email"
        },
        {
          name: "Address Line 1",
          mapTo: "addressLine1"
        },
        {
          name: "Address Line 2",
          mapTo: "addressLine2"
        },
        {
          name: "Address Line 3",
          mapTo: "addressLine3"
        },
        {
          name: "City",
          mapTo: "city"
        },
        {
          name: "Post Code",
          mapTo: "postCode"
        },
        {
          name: "Country",
          mapTo: "country"
        },
        {
          name: "Center",
          mapTo: "centre"
        }
      ]
    };
  },
  computed: {
    modifiedSelectedUnits: function() {
      return this.filteredSelectedUnits;
    },
    disableProceedBtn: function() {
      return this.selectedUnits.length > 0 ? false : true;
    },
    disableRequestBtn: function() {
      // check if all grade are filled in with value
      if (this.grades.length == this.filteredSelectedUnits.length) {
        for (let i = 0; i < this.grades.length; i++) {
          // check if there is grade with empty string
          if (this.grades[i] == "") {
            return true;
          }
        }
        return false;
      }

      return true;
    }
  },
  watch: {
    selectedUnits: function(newValue) {
      this.totalCredits = newValue.reduce(
        (sum, { credits }) => sum + credits,
        0
      );
    },

    filteredSelectedUnits: function(newValue) {
      for (let i = 0; i < newValue.length; i++) {
        for (let j = 0; j < this.unitsNameAndGrade.length; j++) {
          if (newValue[i] == this.unitsNameAndGrade[j].unit) {
            this.grades[i] = this.unitsNameAndGrade[j].grade;
            break;
          }
        }
      }
    }
  },
  methods: {
    onApplyCertification: function(index, learnerId) {
      this.drawerMandatoryUnits = this.mandatoryUnits[index];
      this.drawerOptionalUnits = this.optionalUnits[index];
      this.selectedLearnerId = learnerId;
      this.qualificationIndex = index;
      this.totalCredits = 0;
      this.selectedUnits = [];
    },
    getLearner: function() {
      // execute for new learner summary
      if (this.item) {
        this.writeToTable(this.item);
        return;
      }

      // execute for existing centre summary
      fetch(`${process.env.VUE_APP_ROOT_API}/learners/code/${this.code}`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`
        }
      })
        .then(response => response.json())
        .then(datas => {
          const data = datas.learners[0]; // use the first learner because same data
          data.qualifications = [];

          datas.learners.forEach(learner => {
            learner.qualification.learnerId = learner._id;
            data.qualifications.push(learner.qualification);
            this.certificationCreatedDate.push(
              learner.certificationCreatedDate
            );
          });

          this.learnerQualifications = data.qualifications;

          this.writeToTable(data);

          for (let i = 0; i < data.qualifications.length; i++) {
            const qualification = data.qualifications[i];
            const units = [];

            for (let j = 0; j < qualification.mandatoryUnits.length; j++) {
              let unit = qualification.mandatoryUnits[j];
              units.push({
                name: unit.name,
                type: "mandatory"
              });
            }

            for (let k = 0; k < qualification.optionalUnits.length; k++) {
              let unit = qualification.optionalUnits[k];
              units.push({
                name: unit.name,
                type: "optional"
              });
            }

            this.unitNameAndType.push(units);

            this.mandatoryUnits.push(
              qualification.mandatoryUnits.map(unit => {
                return {
                  code: unit.code,
                  name: unit.name,
                  credits: unit.credits
                };
              })
            );

            this.optionalUnits.push(
              qualification.optionalUnits.map(unit => {
                return {
                  code: unit.code,
                  name: unit.name,
                  credits: unit.credits
                };
              })
            );

            const mandatoryUnitsNameAndId = qualification.mandatoryUnits.map(
              unit => {
                return { name: unit.name, id: unit._id };
              }
            );

            const optionalUnitsNameAndId = qualification.optionalUnits.map(
              unit => {
                return { name: unit.name, id: unit._id };
              }
            );

            this.unitsIdAndName.push(
              ...mandatoryUnitsNameAndId,
              ...optionalUnitsNameAndId
            );
            this.units.push([...this.mandatoryUnits, ...this.optionalUnits]);
            this.units.unshift(qualification.name);
          }
        })
        .catch(error => {
          console.error(error);
        });
    },

    getQualifications: function() {
      const promise = fetch(`${process.env.VUE_APP_ROOT_API}/qualifications`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`
        }
      })
        .then(response => response.json())
        .then(data => {
          this.qualifications = data.qualifications;
          this.gradingCriterion = this.qualifications[0].gradingCriterion.toLowerCase();

          if (this.gradingCriterion == "status") {
            this.gradingOptions = [
              "Fail",
              "Pass",
              "Merit",
              "Distinction",
              "Referral"
            ];
          } else if (this.gradingCriterion == "letter") {
            this.gradingOptions = ["A", "B", "C", "D", "E"];
          } else if (this.gradingCriterion == "percentage") {
            this.gradingOptions = null;
          }
        })
        .catch(error => {
          console.error(error);
        });

      return promise;
    },

    mapQualificationIdToName: function(qualificationId) {
      for (let i = 0; i < this.qualifications.length; i++) {
        if (qualificationId == this.qualifications[i]._id) {
          return this.qualifications[i].name;
        }
      }
    },

    writeToTable: function(item) {
      // to arrange the details to summary table in the desirable order
      this.mapper.map(key => {
        Object.keys(item).map(i => {
          if (key.mapTo == i) {
            if (key.mapTo == "qualification") {
              this.details.push({
                name: key.name,
                value: this.mapQualificationIdToName(item[i]._id)
              });
            } else {
              this.details.push({ name: key.name, value: item[i] });
            }
          }
        });
      });
    },

    onProceedGrading: function() {
      this.gradeDrawer = !this.gradeDrawer;
      this.drawer = !this.drawer;

      // remove the qualification from the selectedUnits
      this.filteredSelectedUnits = this.selectedUnits.filter(
        unit => unit != this.units[0]
      );

      for (let i = 0; i < this.filteredSelectedUnits.length; i++) {
        for (let j = 0; j < this.unitsIdAndName.length; j++) {
          if (
            this.filteredSelectedUnits[i].name == this.unitsIdAndName[j].name
          ) {
            this.selectedUnitsId.push(this.unitsIdAndName[j].id);
            break;
          }
        }
      }
    },

    onEnterGrade: function(unitName, index) {
      let found = false;

      for (let i = 0; i < this.unitsNameAndGrade.length; i++) {
        if (unitName == this.unitsNameAndGrade[i].unit) {
          this.unitsNameAndGrade[i].grade = this.grades[index];
          found = true;
          break;
        }
      }

      if (!found) {
        const data = { unit: unitName, grade: this.grades[index] };
        this.unitsNameAndGrade.push(data);
      }
    },

    onRequestCertification: function() {
      const unitsIdAndGrade = [];

      for (let i = 0; i < this.unitsNameAndGrade.length; i++) {
        for (let j = 0; j < this.unitsIdAndName.length; j++) {
          if (this.unitsNameAndGrade[i].unit == this.unitsIdAndName[j].name) {
            for (
              let k = 0;
              k < this.unitNameAndType[this.qualificationIndex].length;
              k++
            ) {
              if (
                this.unitNameAndType[this.qualificationIndex][k].name ==
                this.unitsNameAndGrade[i].unit
              ) {
                unitsIdAndGrade.push({
                  unitId: this.unitsIdAndName[j].id,
                  grade: this.unitsNameAndGrade[i].grade,
                  gradingCriterion: this.gradingCriterion,
                  type: this.unitNameAndType[this.qualificationIndex][k].type
                });
                break;
              }
            }
          }
        }
      }

      const data = {
        learner: this.selectedLearnerId,
        units: unitsIdAndGrade,
        certificationIssueDate: this.date,
        totalCredits: this.totalCredits
      };

      fetch(`${process.env.VUE_APP_ROOT_API}/certifications`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(data => {
          this.gradeDrawer = false;
          this.selectedUnits = [];
          this.snackbarText = data.message;
          this.snackbar = true;
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>

<style>
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 40px;
}
</style>

<style scoped>
#certificate-side-sheet {
  width: 35% !important;
}

#summary-container {
  min-height: 100vh;
}
</style>
